import { unwrap } from '@hive/api';

/** Relé do acesso remoto publicado pela instalação (R11-12): desligado = relé turn-desativado.invalid. */
export type RelayInfo = { disabled: boolean; relays: string[] };

export type TurnResult = {
  url: string;
  host: string;
  port: number;
  transport: 'udp' | 'tcp';
  answered: boolean;
  allocated: boolean;
  ms: number;
  relayed?: string | null;
  detail: string;
};
export type TurnTest = { disabled: boolean; results: TurnResult[]; at: string };

// endpoints novos (fora do contrato gerado): chamados pelo caminho já preenchido
type Untyped = { GET: (p: never) => Promise<unknown>; POST: (p: never) => Promise<unknown> };

export function loadRelay(api: unknown): Promise<RelayInfo> {
  return unwrap((api as Untyped).GET('/api/v1/remote/relay' as never) as never) as Promise<RelayInfo>;
}

export function testRelay(api: unknown): Promise<TurnTest> {
  return unwrap((api as Untyped).POST('/api/v1/admin/installation-health/turn-test' as never) as never) as Promise<TurnTest>;
}

/** "turn:host:3478?transport=udp" → "turn:host:3478" (o endereço que a tela mostra). */
export function relayLabel(url?: string | null): string {
  return (url ?? '').replace(/\?.*$/, '');
}
